
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;
var specialProduct4 = false;
var specialProduct5 = false;
var noSpecialProduct4 = false;
var specialProduct6 = false;
var specialProduct7 = false;
var specialProduct8 = false;
var specialProduct9 = false;
var specialProduct10 = false;
var specialProduct11 = false;
var specialProduct12 = false;

// The pickers each callback last ran on, to re-apply them after an AJAX cart change
var crLastDateCallbackArgs = null;
var crLastDeliveryDateCallbackArgs = null;

/**
 * Sets the specialProduct flags from the cart items ({collections, name}).
 */
var crSetSpecialProducts = function(items){
specialProduct1 = specialProduct2 = specialProduct3 = specialProduct4 = specialProduct5 = noSpecialProduct4 = false;
specialProduct6 = specialProduct7 = specialProduct8 = specialProduct9 = specialProduct10 = specialProduct11 = specialProduct12 = false;
var crItems = items;
for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('thanksgiving'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Purim 2026'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('passover 2026'.toLowerCase()) > -1) {
    specialProduct3 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Rosh Hashanah/Yom Kippur 2025'.toLowerCase()) > -1) {
    specialProduct4 = true;
  } else {
    noSpecialProduct4 = true;
  }

  if (itemCollections.toLowerCase().indexOf('Super Bowl'.toLowerCase()) > -1) {
    specialProduct6 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Product block'.toLowerCase()) > -1) {
    specialProduct7 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('All Valentines Day Items'.toLowerCase()) > -1) {
    specialProduct8 = true;
  }
  
  if (itemCollections.toLowerCase().indexOf('mother'.toLowerCase()) > -1) {
    specialProduct9 = true;
  }

  if (itemCollections.toLowerCase().indexOf('St. Clair Dance Collective'.toLowerCase()) > -1) {
    specialProduct10 = true;
  }

  if (itemCollections.toLowerCase().indexOf('Father'.toLowerCase()) > -1) {
    specialProduct11 = true;
  }

  if (itemCollections.toLowerCase().indexOf('Halloween 2026'.toLowerCase()) > -1) {
    specialProduct12 = true;
  }

  // if (itemCollections.toLowerCase().indexOf('Camp DOT cake'.toLowerCase()) > -1) {
  //   specialProduct12 = true;
  // }

  // if (itemCollections.toLowerCase().indexOf('High Holidays 2026'.toLowerCase()) > -1) {
  //   specialProduct12 = true;
  // }

  
  

  //if (itemCollections.toLowerCase().indexOf('Honey Cake'.toLowerCase()) > -1) {
  //  specialProduct5 = true;
  //} 

  // if (itemTitle.toLowerCase().indexOf('Christmas Whole Roasted Capon'.toLowerCase()) > -1) {
  //   specialProduct2 = true;
  // } 

  // if (itemTitle.toLowerCase().indexOf('Holiday Mini-Loaf'.toLowerCase()) > -1) {
  //   specialProduct3 = true;
  // } 
}
}
crSetSpecialProducts(crItems);

/**
 * Re-reads the cart after an AJAX change (add to cart, drawer quantity...):
 * crItems is only rendered on page load. The lines come from /cart.js and their
 * collections from the Storefront API, then both date pickers are re-applied.
 */
document.addEventListener('cr:cart:updated', function(){
  fetch('/cart.js').then(function(response) { return response.json(); }).then(function(cart) {
    var productIds = cart.items
      .map(function(item) { return 'gid://shopify/Product/' + item.product_id; })
      .filter(function(id, index, ids) { return ids.indexOf(id) === index; });
    return fetch('/api/2026-07/graphql.json', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        query: 'query CrCartCollections($ids: [ID!]!) { nodes(ids: $ids) { ... on Product { id collections(first: 100) { nodes { title } } } } }',
        variables: {ids: productIds}
      })
    }).then(function(response) { return response.json(); }).then(function(result) {
      var titlesByProduct = {};
      result.data.nodes.forEach(function(product) {
        if (product) titlesByProduct[product.id] = product.collections.nodes.map(function(collection) { return collection.title; });
      });
      crSetSpecialProducts(cart.items.map(function(item) {
        return {
          name: item.title,
          collections: ' ' + (titlesByProduct['gid://shopify/Product/' + item.product_id] || []).join(' ')
        };
      }));
      if (crLastDateCallbackArgs) {
        crDateCallback.apply(null, crLastDateCallbackArgs);
        // As the app does after this callback: the products' lead time still sets the earliest date
        if (window.storePickup && storePickup.raisePickerMin) storePickup.raisePickerMin(crLastDateCallbackArgs[0], storePickup.leadTimeDays('pickup'));
      }
      if (crLastDeliveryDateCallbackArgs) crDeliveryDateCallback.apply(null, crLastDeliveryDateCallbackArgs);
    });
  }).catch(function(error) {
    // Keep the flags from the last cart that could be read
    console.error('Unable to re-check the special products.', error);
  });
});

/*document.addEventListener('crJQActivated', function (e) {
  if (specialProduct4 === true && noSpecialProduct4 === true) {
    jqCR('.pickup-wrapper').remove()
    jqCR('.cart__ctas').html('')
  }
  
})*/


var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  crLastDateCallbackArgs = [picker, selectedStore, blackoutdatesCollection];
  if (specialProduct12 === true) {
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2026, 9, 28] }, 
                           { from: [2026, 10, 2], to: [2045, 11, 16] },
                           //{ from: [2025, 11, 22], to: [2045, 11, 16] },
                          ]);
    picker.set('min', 0);                             
    picker.set('max', 100);   
  } 
  // else if (specialProduct12 === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2025, 1, 7], to: [2026, 8, 19] },                                                                                 
  //                          { from: [2026, 8, 21], to: [2045, 11, 16] },
  //                         ]);
  //   picker.set('min', 0);   
  //   picker.set('max', 100);   
  // } 
  else if (specialProduct10 === true) {
  	picker.set('disable', [true, 
                           { from: [2025, 1, 7], to: [2026, 5, 19] },                                                                                 
                           { from: [2026, 5, 21], to: [2045, 11, 16] },
                          ]);
    picker.set('min', 0);   
    picker.set('max', 100);   
  } 
  else if (specialProduct7 === true) {
  	picker.set('disable', [true, 
                           { from: [2026, 1, 7], to: [2026, 1, 8] },                                                       
                          ]);
    picker.set('min', 0);   
    picker.set('max', 100);   
  } 
  else if (specialProduct2 === true) {
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2026, 1, 24] }, 
                           { from: [2026, 2, 2], to: [2026, 2, 2] }, 
                           { from: [2026, 2, 4], to: [2034, 11, 17] },
                           
                          ]);
    //picker.set('min', 0);   
    //picker.set('max', 100);   
  } 
  // else if (specialProduct4 === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2020, 8, 10], to: [2025, 8, 30] }, 
  //                          { from: [2025, 9, 2], to: [2034, 11, 17] },
                           
  //                         ]);
  //   picker.set('min', 0);   
  //   picker.set('max', 100);   
  // } 
  else if (specialProduct3 === true) {
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2026, 2, 31] }, 
                           { from: [2026, 3, 2], to: [2034, 11, 17] },
                           
                          ]);
    picker.set('max', 100);   
  } 
  //else if (specialProduct1 === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2025, 8, 15], to: [2025, 9, 15] }, 
  //                         // { from: [2025, 1, 10], to: [2034, 11, 17] },
  //                          //{ from: [2024, 11, 23], to: [2034, 11, 18] }
  //                         ]);
  //   picker.set('max', 100);   
  //   picker.set('disable', blackoutdatesCollection);
  // }	else if (specialProduct2 === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2020, 8, 10], to: [2025, 2, 14] }, 
  //                          { from: [2025, 2, 17], to: [2034, 11, 17] },
                           
  //                         ]);
  //   picker.set('max', 100);   
  // }	
  else {
    picker.set('disable', blackoutdatesCollection);
  }  
}

var crDeliveryDateCallback = function(picker, blackoutdatesCollection){
  crLastDeliveryDateCallbackArgs = [picker, blackoutdatesCollection];
 if (specialProduct12 === true) {
  console.log('Special product 1')
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2026, 9, 28] }, 
                           { from: [2026, 10, 2], to: [2045, 11, 16] },
                           //{ from: [2025, 11, 22], to: [2045, 11, 16] },
                          ]);
    picker.set('min', 0);                             
    picker.set('max', 100);   
  } 
  // else if (specialProduct12 === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2025, 1, 7], to: [2026, 8, 19] },                                                                                 
  //                          { from: [2026, 8, 21], to: [2045, 11, 16] },
  //                         ]);
  //   picker.set('min', 0);   
  //   picker.set('max', 100);   
  // } 
  // else if (specialProduct9 === true) {
  // 	picker.set('disable', [true, 
  //                          { from: [2025, 1, 7], to: [2026, 4, 8] },                                                                                 
  //                          { from: [2026, 4, 10], to: [2045, 11, 16] },
                           
  //                         ]);
  //   picker.set('max', 100);   
  // } 
  else if (specialProduct8 === true) {
  	picker.set('disable', [true, 
                           { from: [2025, 1, 7], to: [2026, 1, 12] },    
                                 
                           { from: [2026, 1, 16], to: [2045, 11, 16] },
                          ]);
    picker.set('min', 0);   
    picker.set('max', 100);   
  } 
  else if (specialProduct7 === true) {
  	picker.set('disable', [true, 
                           { from: [2026, 1, 7], to: [2026, 1, 8] },                                                       
                          ]);
    picker.set('min', 0);   
    picker.set('max', 100);   
  } 
  else if (specialProduct2 === true) {
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2026, 1, 24] }, 
                           { from: [2026, 2, 2], to: [2026, 2, 2] }, 
                           { from: [2026, 2, 4], to: [2034, 11, 17] },
                           
                          ]);
    //picker.set('min', 0);   
    //picker.set('max', 100);   
  } 
//   if (specialProduct4 === true) {
//   	picker.set('disable', [true, 
//                            { from: [2020, 8, 10], to: [2025, 8, 30] }, 
//                            { from: [2025, 9, 2], to: [2034, 11, 17] },
                           
//                           ]);
//     picker.set('min', 0);                             
//     picker.set('max', 100);   
//   } else
//   if (specialProduct1 === true) {
//   	picker.set('disable', [true, 
//                           { from: [2025, 8, 15], to: [2025, 9, 15] }, 
//                            //{ from: [2025, 1, 10], to: [2034, 11, 17] },
//                            //{ from: [2024, 11, 23], to: [2034, 11, 18] }
//                           ]);
//     picker.set('max', 100);   
//     picker.set('disable', blackoutdatesCollection);
//   } else if (specialProduct2 === true) {
//   	picker.set('disable', [true, 
//                            { from: [2020, 8, 10], to: [2025, 2, 14] }, 
//                            { from: [2025, 2, 17], to: [2034, 11, 17] },
                           
//                           ]);
//     picker.set('max', 100);   
//   }
 else {
    picker.set('disable', blackoutdatesCollection);
  } 
}

// var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
//   console.log(selectedDay, selectedDate, selectedMonth);
//   if (specialProduct2 === true) {
//     if(selectedDate.getDate() === 13 && selectedMonth === 1 && selectedDate.getFullYear() === 2025) {
//       //timepicker.set('disable',[{ from: [11, 00], to: [11, 00] }]); 
//       timepicker.set('min',[16, 0]); 
//       timepicker.set('max',[18, 0]);
//     }  
//   }
  
	
// }